angular.module('app.directives.tooltip',[]).
directive('tooltip',
    [function(){
        var removeClass = function(){
            var divs = document.getElementsByClassName('showhint')
            angular.element(divs).removeClass('showhint');
        }

        angular.element(document).on('click', function(){
            removeClass();
        });
        return {
            scope:{
                ngModel:'=ngModel'
            },
            template:"<span class=\"tooltip\" ><p ng-bind-html=\"ngModel | newlines\"></p><span class=\"close obj-icon icon-loeschen-abbrechen-small\"></span></span>",

            link:function(scope,elem,attr){
                elem.bind('click', function(event) {
                    var hasClass = elem.hasClass('showhint');
                    removeClass();
                    if (!hasClass)  elem.addClass('showhint');
                    event.stopPropagation();
                });
            }
        }

    }]
);
